module.exports = __webpack_public_path__ + "03_glasses_red.be6526ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/03_glasses_red.png
// module id = 8II7
// module chunks = 0